<!-- 只有一个 点击上传 按钮 可上传多张图片的 -->
<template>
	<div class="multi-upload">
		<el-upload
			class="upload-demo"
			list-type="picture"
			multiple
			:data="additionalData"
			:headers="headers"
			:action="uploadImgUrl"
			:file-list="fileList"
			:limit="props.limit"
			:before-upload="handleBeforeUpload"
			:on-success="handleUploadSuccess"
			:on-error="handleUploadError"
			:on-change="handleChange"
			:on-preview="handlePreview"
			:on-remove="handleRemove"
			:on-exceed="handleExceed">
			<el-button size="small" type="primary">点击上传</el-button>
			<template #file="{ file }">
				<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
				<label class="el-upload-list__item-status-label">
					<span class="el-icon el-icon--upload-success el-icon--check">
						<el-icon><Check /></el-icon>
					</span>
				</label>
				<label class="el-upload-set">
					<span class="set-span" @click="onSetMainImage(file.url)">设为封面图</span>
				</label>
				<span class="el-icon--close" @click="handleRemove(file)">
					<el-icon><Close /></el-icon>
				</span>
			</template>
			<div slot="tip" class="el-upload__tip">只能上传{{ fileType.join('/') }}文件，上限{{ limit }}个，且单个不超过{{ fileSize }}M</div>
		</el-upload>
	</div>
</template>

<script setup>
import { ElMessage, ElMessageBox } from 'element-plus'
import { getToken } from '@/utils/auth'
import { checkFileUpload } from '@/utils/scm'
import { listToString, useImageUrl } from '@/utils/dynamic'
import defaultSettings from '@/settings'

const emit = defineEmits(['update:modelValue', 'update:mainImage'])

const props = defineProps({
	modelValue: [String, Object, Array],
	// 图片数量限制
	limit: {
		type: Number,
		default: 5
	},
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 5
	},
	// 文件类型, 例如['png', 'jpg', 'jpeg']
	fileType: {
		type: Array,
		default: () => ['png', 'jpg', 'jpeg', 'gif']
	},
	// 是否显示提示
	isShowTip: {
		type: Boolean,
		default: true
	}
})

const uploadImgUrl = ref(defaultSettings.fileUploadUrl) // 上传的图片服务器地址
const additionalData = ref({
	belongApp: defaultSettings.app,
	belongAppId: defaultSettings.appId
})

const headers = ref({ Authorization: 'Bearer ' + getToken() })

const fileList = ref([]) //显示的列表
const modeList = ref([]) //正确的列表

//使用 before-upload 限制用户上传的图片格式和大小
function handleBeforeUpload(file) {
	return checkFileUpload(file, props.fileType, props.fileSize)
}
// 文件超出限制回调
function handleExceed(files, uploadFiles) {
	ElMessage.warning(`最多仅可上传 ${props.limit} 个文件`)
}

//上传成功, 数据双向绑定
function handleUploadSuccess(res, files, fileList) {
	// 延时逻辑
	setTimeout(() => {
		if (res && res.ResData) {
			//当前上传的临时URL
			let curUrl = files.url
			//当前上传正确的图片信息
			let cname = res.ResData.FileName
			let cicon = res.ResData.FilePath
			modeList.value = []
			fileList.value = fileList
			//把临时的指替换成正确的值
			fileList.value.forEach((item, index) => {
				let name = item.name
				let url = item.url
				if (item.url == curUrl) {
					name = cname
					url = cicon
				}
				modeList.value.push({ name: name, url: url })
			})
			//更新正确的值用于提交到后端
			emit('update:modelValue', listToString(modeList.value))
		} else {
			ElMessage.error(res.ErrMsg)
		}
	}, 1000) // 延时1秒
}
// 上传失败
function handleUploadError(error, file, fileList) {
	ElMessageBox({
		type: 'error',
		title: '上传失败',
		message: `${file.name} 上传失败: ${error.message}`,
		showCancelButton: false,
		confirmButtonText: 'OK'
	})
}
// 文件状态改变回调
const handleChange = (file, files) => {
	fileList.value = files
}

// 预览
function handlePreview(file) {
	//console.log(file)
}

// 删除图片
function handleRemove(file, files) {
	fileList.value = files
	fileList.value = fileList.value.filter((i) => i.url != file.url)
	emit('update:modelValue', listToString(fileList.value))
}
function onSetMainImage(url) {
	emit('update:mainImage', url)
}
// 因为props.modelValue是非引用类型，改变时，需要监听，对响应式数据重新赋值
watch(
	() => props.modelValue,
	(val) => {
		if (val != null && val != '') {
			// 首先将值转为数组
			let list = Array.isArray(val) ? val : val.split(',')
			// 然后将数组转为对象数组
			fileList.value = list.map((item) => {
				if (typeof item === 'string') {
					//显示时加路径
					return { name: item, url: useImageUrl(item) }
				}
			})
		}
	},
	{
		immediate: true,
		deep: true
	}
)
</script>

<style scoped lang="scss">
.multi-upload {
	.upload-demo {
		margin: 0 10px;
	}
	.el-upload__tip {
		padding-left: 5px;
	}
	.el-upload-list--picture {
		.el-upload-list__item {
			border: 1px solid #e4e7ed;
			float: left;
			width: 100px;
			height: 100px;
			margin: 0px 2px;
			text-align: center;
			z-index: 10;

			.el-upload-list__item-status-label {
				z-index: 20;
			}
			.el-icon--close {
				z-index: 20;
			}
		}
	}
	.el-upload-set {
		position: absolute;
		right: 10px;
		bottom: 0px;
		width: 60px;
		height: 27px;
		display: inline-flex;
		text-align: center;

		.set-span {
			font-size: 9px !important;
			line-height: 20px;
			padding-left: 12px;
			color: #409eff;
			cursor: pointer;
		}
	}
}
</style>
